import { ApiService } from "@/services";
import { APIConfig } from "@/constants";


const getSubscriptionPlans = (payload: any) => {
    return ApiService[APIConfig.GET_SUBSCRIPTION_PLANS.METHOD](APIConfig.GET_SUBSCRIPTION_PLANS.URL, payload);
}

const getTopupPlans = (payload: any) => {
    return ApiService[APIConfig.GET_TOPUP_PLANS.METHOD](APIConfig.GET_TOPUP_PLANS.URL, payload);
}

const subscribe = (payload: any) => {
    return ApiService[APIConfig.SUBSCRIBE.METHOD](APIConfig.SUBSCRIBE.URL, payload);
}

const addTokenCreditsAPICall = (payload: any) => {
    return ApiService[APIConfig.ADD_TOKEN_CREDITS.METHOD](APIConfig.ADD_TOKEN_CREDITS.URL, payload);
}

const createTransaction = (payload: any) => {
    return ApiService[APIConfig.CREATE_TRANSACTION.METHOD](APIConfig.CREATE_TRANSACTION.URL, payload);
}

const createTopupTransaction = (payload: any) => {
    return ApiService[APIConfig.CREATE_TOPUP_TRANSACTION.METHOD](APIConfig.CREATE_TOPUP_TRANSACTION.URL, payload);
}

const checkTransaction = (transactionId: string, payload?: any) => {
    return ApiService[APIConfig.CHECK_TRANSACTION.METHOD](APIConfig.CHECK_TRANSACTION.URL(transactionId), payload);
}

const getSubscriptions = (payload: any) => {
    return ApiService[APIConfig.GET_SUBSCRIPTIONS.METHOD](APIConfig.GET_SUBSCRIPTIONS.URL, payload);
}

const cancelSubscription = (subscriptionId: string, payload?: any) => {
    return ApiService[APIConfig.CANCEL_SUBSCRIPTION.METHOD](APIConfig.CANCEL_SUBSCRIPTION.URL(subscriptionId), payload);
}


const PaymentService = {
    getSubscriptionPlans,
    getTopupPlans,
    subscribe,
    addTokenCreditsAPICall,
    createTransaction,
    createTopupTransaction,
    checkTransaction,
    getSubscriptions,
    cancelSubscription
}

export default PaymentService;
